'use client';

import { getSocialLinks } from '@/services/storeService';
import { usePathname } from 'next/navigation';
import React from 'react';

export const WhatsAppIcon: React.FC = () => {
  const pathname = usePathname();

  const blockedExact = ['/checkout', '/cart', '/signin'];
  const blockedPrefixes = ['/p/', '/products/'];

  const isBlocked =
    blockedExact.includes(pathname) ||
    blockedPrefixes.some((prefix) => pathname.startsWith(prefix));

  if (isBlocked) return null;

  const socials = getSocialLinks();
  if (!socials?.length) return null;


  const whatsapp = socials.find((s: any) => {
    const nameLower = s.name?.toLowerCase();
    return nameLower?.includes('whatsapp') && s.status === 1; // Fixed: 1 instead of true
  });

  if (!whatsapp) {
    return null;
  }

  return (
    <a
      href={whatsapp.value}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed z-30 bottom-4 left-4"
      style={{ textDecoration: 'none' }}
    >
      <img
        src="https://vilva-backup.blr1.digitaloceanspaces.com/vilvabusiness/common%20files/whatsappIconOfEcom.webp"
        alt="WhatsApp Chat"
        className="w-[55px] h-[55px] object-contain drop-shadow-lg transition-transform hover:scale-110"
        loading="lazy"
      />
    </a>
  );
};